import React, { useContext, useState } from 'react';

import { ReactComponent as SlackIcon } from '../../../assets/svg/logo_slack.svg';
import  AdAccountsIcon from '../../../assets/svg/Icon_adaccounts.png';
import { ModalWindow, ActionLink, AppTooltip } from '../../atoms';

import { DashboardContext, UserContext } from '../../../context';
import { DashService } from '../../../services';
import { default as t } from '../../../utils/i18n';
import config from '../../../utils/config';

import './ac-list-item.scss';

const HELP_EMAIL_ID = config.get('help', 'support_email');

function AcListItem({ affectedAdAccount, listIndex, selectedIndex, setSelectedIndex }) {
  const { dashData, setDashData } = useContext(DashboardContext);
  const { user } = useContext(UserContext);

  const [channelDetails, setChannelDetails] = useState({});
  const [joinUrl, setJoinUrl] = useState('');
  const [showSlackSuccessModal, setShowSlackSuccessModal] = useState(false);
  const [showSlackErrorModal, setShowSlackErrorModal] = useState(false);
  const [showSlackUserNotFoundModal, setShowSlackUserNotFoundModal] = useState(false);

  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const { businessAcId } = dashData;

  const handleOnClick = e => {
    if(e.target.parentNode.parentNode === e.currentTarget){
    if (e.target.id === 'whiteBG') return;
    setSelectedIndex(listIndex);
    const selectedAffectedAccount = affectedAdAccount;
   setDashData(prevDashData => ({
      ...prevDashData,
      adAcTitle: selectedAffectedAccount?.adAccount?.name,
      adAcId: selectedAffectedAccount?.adAccount?.id,
      currencySymbol: selectedAffectedAccount?.adAccount?.currency,
      isAdAcAdmin: selectedAffectedAccount?.adAccount?.role?.includes('MANAGE'),
      pauseAdset: selectedAffectedAccount?.adAccount?.pauseAdset,
    }));
  }
  };

  const toggleNotificationWindow = e => {
    setShowSlackSuccessModal(false);
    setShowSlackErrorModal(false);
    setShowSlackUserNotFoundModal(false);
  };

  const onSlackSubscribe = async () => {
     try {
      const slackSubscribeResponse = await DashService.slackSubscribe(userAccessToken, username.toLowerCase(), {
        businessAccountId: businessAcId,
        adAccountId: affectedAdAccount?.adAccount?.id,
      });
      const slackChannelData = slackSubscribeResponse.data?.data?.channel;
      setShowSlackSuccessModal(true);
      setChannelDetails(slackChannelData);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        ////console.log(dataCode);
      }
      if (
        !dataCode ||
        dataCode === 'CL_DASH_009' ||
        dataCode === 'CL_DASH_010' ||
        dataCode === 'CL_DASH_012'
      ) {
        setShowSlackErrorModal(true);
      } else if (dataCode === 'CL_DASH_011') {
        setShowSlackUserNotFoundModal(true);
        setJoinUrl(error?.data?.data?.joinURL);
      }
    }
  };

  return (
    <li
      className={`c-adaccounts--listitem ${listIndex === selectedIndex ? 'selected' : null}`}
      onClick={handleOnClick}
    >
      <div className="c-adaccounts--adaccountName">
        <img src={AdAccountsIcon} alt="AdAccounts Icon" />
        <span className="c-adaccounts--adaccountNameError">
          {affectedAdAccount.failedEntityCount}
        </span>
        <span className="account-name">{affectedAdAccount.adAccount.name}</span>
      </div>

      <div>
        <a id="slack-link" href="#slacknotification" onClick={onSlackSubscribe}>
          <SlackIcon
            className="iconslack"
            data-tip={t('slack.icon.tooltip.clickToSubscribe')}
            data-classname="c-adaccounts--tootip"
            data-for="slackNotificationTip"
          />
          <AppTooltip id="slackNotificationTip" className="c-adaccounts--tooltip" />
        </a>
        <ModalWindow
          className="fqa-modal--notification"
          isOpen={showSlackSuccessModal}
          onRequestClose={toggleNotificationWindow}
          heading={t('slack.modal.success.text.header')}
        >
          <h3 className="fqa-model--message">{t('slack.modal.success.text.body')} {affectedAdAccount.adAccount.name}</h3>
          {/* <h3 className="fqa-model--message-title">{affectedAdAccount.adAccount.name}</h3> */}

          <div className="fqa-model--actions">
            <div className="fqa-model--actions-link">
              <ActionLink
                anchor={true}
                value={t('slack.modal.body.text.openInBrowser')}
                href={channelDetails['web_url']}
              />
            </div>
            <div className="fqa-model--actions-link">
              <ActionLink
                anchor={true}
                value={t('slack.modal.body.text.openInSlack')}
                href={channelDetails['app_url']}
              />
            </div>
          </div>
        </ModalWindow>

        <ModalWindow
          className="fqa-modal--notification"
          isOpen={showSlackErrorModal}
          onRequestClose={toggleNotificationWindow}
          heading={t('error.CL_DASH_010')}
        >
          <span>
            {t('slack.modal.body.error.CL_DASH_010')} {HELP_EMAIL_ID}
          </span>
        </ModalWindow>

        <ModalWindow
          className="fqa-modal--notification"
          isOpen={showSlackUserNotFoundModal}
          onRequestClose={toggleNotificationWindow}
          heading={t('error.CL_DASH_011')}
        >
          <h3>{t('slack.modal.body.error.CL_DASH_011.header')}:</h3>
          <ul className="fqa-modal--error-hints c-text-heading-3">
            <li>{t('slack.modal.body.error.CL_DASH_011.hint1')}</li>
            <li>{t('slack.modal.body.error.CL_DASH_011.hint2')}</li>
            <li>{t('slack.modal.body.error.CL_DASH_011.hint3')}</li>
            <li>
              {t('slack.modal.body.error.CL_DASH_011.hint4.part1')}{' '}
              <ActionLink
                anchor={true}
                href={joinUrl}
                value={t('slack.modal.body.error.CL_DASH_011.hint4.joinUrl')}
              />{' '}
              {t('slack.modal.body.error.CL_DASH_011.hint4.part2')}
            </li>
          </ul>
        </ModalWindow>
      </div>
    </li>
  );
}

export default AcListItem;
